import { Card, Button, Row, Col, Form } from 'react-bootstrap';
import { CartContext } from '../CartContext';
import { useContext } from 'react';

function ProductCard (props) {
    const product = props.product;
    const cart = useContext(CartContext);
    const productQuantity = cart.getProductQuantity(product.id);

    return (
        <Row>
            <Col>
                <Card className='border-0'>
                    <Card.Body>
                        {product.pics}
                        <Card.Title className='mt-4'>{product.title}</Card.Title>
                        <Card.Title class="fw-normal">{product.title2}</Card.Title>
                        <Card.Text class="mt-2">${product.price}</Card.Text>
                        { productQuantity > 0 ?
                            <>
                                <Form as={Row}>
                                    <Form.Label column="true" sm="6">In Cart: {productQuantity} </Form.Label>
                                    <Col sm="6">
                                        <Button variant='outline-secondary' onClick={() => cart.addOneToCart(product.id)} sm="6" className='mx-2'>+</Button>
                                        <Button variant='outline-danger' onClick={() => cart.removeOneFromCart(product.id)} sm="6" className='mx-2'>-</Button>
                                    </Col>
                                </Form>
                                <Button onClick={() => cart.deleteFromCart(product.id)} variant='danger' className='my-2'>Remove from cart</Button>
                            </>
                            :
                            <Button variant='outline-secondary' onClick={() => cart.addOneToCart(product.id)}>Add To Cart</Button>
                        }
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

export default ProductCard;